import { combineReducers } from 'redux';
import user from './user';
import products from './products';

export const Reducers = combineReducers({
    user: user,
    products: products
});